import { type Trello } from "./types/trello"
import { CAPABILITY_PROPS, PUP_DISPLAY_NAME } from "./config"
import { getOnEnable } from "./on-enable/capability"
import { getShowAuthorization } from "./show-authorization/capability"
import { getAuthorizationStatus } from "./authorization-status/capability"
import { getShowSettings } from "./show-settings/capability"
import { getRemoveData } from "./remove-data/capability"
import { getCardButton } from "./link-settings/capability"
import { getLogTimeCardButton } from "./log-time/capability"
import { getCardBackSection } from "./card-back-section/capability"
import { getBoardButton } from "./time-report/capability"
import { getCardBadges, getCardDetailBadges } from "./card-badges/capability"
import { getStoredBoardMode } from "./storage"

window.TrelloPowerUp.initialize(
  {
    "on-enable": (t: Trello.PowerUp.IFrame) => getOnEnable(t),
    "show-settings": async (t: Trello.PowerUp.IFrame) => await getShowSettings(t),
    'show-authorization': (t: Trello.PowerUp.IFrame) =>
    getShowAuthorization(t),
    'authorization-status': async (t: Trello.PowerUp.IFrame) => {
      return await getAuthorizationStatus(t)
    },
    'remove-data': async (t: Trello.PowerUp.IFrame) => await getRemoveData(t),
    // One button, whichever the board is set up for. The two ways of working
    // are never both on — see storage.ts — so a board doing timesheets is not
    // offered the customer set-up it exists to avoid.
    "card-buttons": async (t: Trello.PowerUp.IFrame) =>
      (await getStoredBoardMode(t)) === "time"
        ? await getLogTimeCardButton(t, CAPABILITY_PROPS)
        : await getCardButton(t, CAPABILITY_PROPS),
    // The time report belongs to the time-tracking way of working only.
    "board-buttons": async (t: Trello.PowerUp.IFrame) =>
      (await getStoredBoardMode(t)) === "time" ? await getBoardButton(t, CAPABILITY_PROPS) : [],
    'card-back-section': async (t: Trello.PowerUp.IFrame) =>
    await getCardBackSection(t, CAPABILITY_PROPS, await getStoredBoardMode(t)),
    // Both modes badge a card, with whichever fact that mode is about: the
    // linked customer, or the time tracked to it.
    'card-badges': async (t: Trello.PowerUp.IFrame) =>
      await getCardBadges(t, CAPABILITY_PROPS, await getStoredBoardMode(t)),
    'card-detail-badges': async (t: Trello.PowerUp.IFrame) =>
      await getCardDetailBadges(t, CAPABILITY_PROPS, await getStoredBoardMode(t)),
  },
  {
    appKey: import.meta.env.VITE_POWERUP_APP_KEY,
    appName: PUP_DISPLAY_NAME
  }
)
